export default "__VITE_ASSET__BeI47kME__"